var map = {
	"./baac.jpg": "e45b",
	"./bankokbank.jpg": "029f",
	"./cimb.jpg": "3a74",
	"./ghbank.jpg": "d1a9",
	"./gsb.jpg": "d79f",
	"./hbl.jpg": "c46c",
	"./icbc.jpg": "9bed",
	"./kbank.jpg": "25e9",
	"./kiatnakin.jpg": "f79e",
	"./krungsri.jpg": "6827",
	"./ktb.jpg": "ed77",
	"./lh.jpg": "d9be",
	"./scb.jpg": "c6ff",
	"./standard.jpg": "ac03",
	"./tisco.jpg": "3b85",
	"./truewallet.jpg": "6466",
	"./ttb.jpg": "2906",
	"./uob.jpg": "5191",
	"./ธนาคารอิสลาม.jpg": "0387"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "92ba";